import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment/moment';
import * as XLSX from 'xlsx';

const momentDate: any = moment;

@Component({
  selector: 'app-customer-contract-report',
  templateUrl: './customer-active-inactive-report.component.html',
  styleUrls: ['./customer-active-inactive-report.component.scss']
})
export class CustomerContractReportComponent implements OnInit {
  loading: boolean = true;
  orgId: any;
  userId: any;
  p: number = 1;
  search: any;
  selectedCustomerDetails: any;
  startingCount: number = 0;
  endingCount: number = 0;
  allRows: any[] = [];
  filteredRows: any[] = [];
  statusFilter = {
    active: true,
    inactive: true,
    expired: true,
  };
  summary: any = {
    active: 0,
    inactive: 0,
    expired: 0,
  };

  formatReportDate(value: any) {
    if (value === undefined || value === null || value === '') {
      return '';
    }

    const dateValue = String(value).trim();
    const dateParts = dateValue.match(/^(\d{1,6})-(\d{1,2})-(\d{1,2})$/);

    if (!dateParts) {
      return dateValue;
    }

    const day = parseInt(dateParts[3], 10);
    const month = parseInt(dateParts[2], 10);
    const year = dateParts[1];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    if (isNaN(day) || isNaN(month) || month < 1 || month > 12) {
      return dateValue;
    }

    return day + ' ' + monthNames[month - 1] + ' ' + year;
  }

  constructor(private http: Http, private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null) {
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
      return;
    }

    this.orgId = this.route.params['value'].orgId;
    this.userId = this.route.params['value'].userId;
    this.loadReport();
  }

  loadReport() {
    this.loading = true;
    const reportObj = {
      'orgId': this.orgId
    };

    return this.http.post('/api/getCustomerStatusSummaryReport', reportObj).subscribe(
      (res: any) => {
        const response = res.json() || [];
        this.allRows = [];
        this.summary = {
          active: 0,
          inactive: 0,
          expired: 0,
        };

        for (let index = 0; index < response.length; index++) {
          const row = response[index];
          const reportRow = {
            id: row._id,
            customerName: row.customer_Name || row.client_Name,
            phoneNumber: row.phone_Number || '',
            landlineNumber: row.landline_Number || '',
            contactName: row.ContactName || '',
            department: row.Department || '',
            contactNumber: row.ContactNumber || '',
            email: row.Email || '',
            contractLevel: row.contractLevel,
            contractReference: row.contract_Reference,
            serialNumber: row.serial_Number,
            make: row.make || '',
            model: row.model || '',
            hmr: row.hmr || '',
            noOfService: row.no_Of_Service,
            completedServiceCount: row.completed_Service_Count || 0,
            startDate: this.formatReportDate(row.start_Date),
            endDate: this.formatReportDate(row.end_Date),
            originalEndDate: this.formatReportDate(row.original_end_date),
            lastCompletedServiceDate: this.formatReportDate(row.last_Completed_Service_Date),
            reportStatus: row.reportStatus,
            reportStatusLabel: this.getStatusLabel(row.reportStatus),
            remarks: row.remarks || '',
          };

          this.allRows.push(reportRow);
          if (this.summary[row.reportStatus] !== undefined) {
            this.summary[row.reportStatus] = this.summary[row.reportStatus] + 1;
          }
        }

        this.applyFilters();
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('unable to load customer status report');
      }
    );
  }

  applyFilters() {
    const selectedStatuses = [];
    if (this.statusFilter.active) {
      selectedStatuses.push('active');
    }
    if (this.statusFilter.inactive) {
      selectedStatuses.push('inactive');
    }
    if (this.statusFilter.expired) {
      selectedStatuses.push('expired');
    }

    this.filteredRows = [];
    for (let index = 0; index < this.allRows.length; index++) {
      if (selectedStatuses.indexOf(this.allRows[index].reportStatus) !== -1) {
        this.filteredRows.push(this.allRows[index]);
      }
    }

    this.p = 1;
    this.getCount();
  }

  getStatusLabel(status: any) {
    if (status === 'expired') {
      return 'Expired';
    }

    if (status === 'inactive') {
      return 'Inactive';
    }

    return 'Active';
  }

  getCount() {
    if (this.filteredRows.length === 0) {
      this.startingCount = 0;
      this.endingCount = 0;
      return;
    }

    if (this.p < Math.ceil(this.filteredRows.length / 10)) {
      this.startingCount = (this.p - 1) * 10;
      if (this.startingCount === 0) {
        this.startingCount = 1;
      }
      this.endingCount = this.p * 10;
    } else {
      const count = this.filteredRows.length % 10 || 10;
      this.startingCount = (this.p - 1) * 10;
      this.endingCount = this.startingCount + count;
      if (this.startingCount === 0) {
        this.startingCount = 1;
        this.endingCount = count;
      }
    }
  }

  exportToExcel() {
    if (this.filteredRows.length <= 0) {
      alert('no records available to export');
      return;
    }

    let data = [];
    let title = 'Customer Contract Report.xlsx';
    data.push(['Customer Contract Report']);
    data.push([]);
    data.push(['S NO', 'CUSTOMER NAME', 'PHONE NUMBER', 'LANDLINE NUMBER', 'CONTACT NAME', 'DEPARTMENT', 'CONTACT NUMBER', 'EMAIL', 'SERIAL NUMBER', 'CONTRACT LEVEL', 'MAKE', 'MODEL', 'NO OF SERVICE', 'CONTRACT REFERENCE', 'COMPLETED SERVICE COUNT', 'HMR', 'START DATE', 'END DATE', 'ORIGINAL END DATE', 'LAST COMPLETED SERVICE DATE', 'STATUS', 'REMARKS']);
    for (let index = 0; index < this.filteredRows.length; index++) {
      data.push([
        index + 1,
        this.filteredRows[index].customerName,
        this.filteredRows[index].phoneNumber,
        this.filteredRows[index].landlineNumber,
        this.filteredRows[index].contactName,
        this.filteredRows[index].department,
        this.filteredRows[index].contactNumber,
        this.filteredRows[index].email,
        this.filteredRows[index].serialNumber,
        this.filteredRows[index].contractLevel,
        this.filteredRows[index].make,
        this.filteredRows[index].model,
        this.filteredRows[index].noOfService,
        this.filteredRows[index].contractReference,
        this.filteredRows[index].completedServiceCount,
        this.filteredRows[index].hmr,
        this.filteredRows[index].startDate,
        this.filteredRows[index].endDate,
        this.filteredRows[index].originalEndDate || '-',
        this.filteredRows[index].lastCompletedServiceDate || '-',
        this.filteredRows[index].reportStatusLabel,
        this.filteredRows[index].remarks,
      ]);
    }

    let wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Customer Contract Report');
    XLSX.writeFile(wb, title);
  }

  openCustomerDetails(row: any) {
    this.selectedCustomerDetails = row;
  }

  closeCustomerDetails() {
    this.selectedCustomerDetails = null;
  }
}



// WEBPACK FOOTER //
// ./client/app/customer-active-inactive-report/customer-active-inactive-report.component.ts